export class LocalStorageKeys {
  public static BuildingsMarkersKey = 'building-markers';
  public static DashboardKey = 'dashboard';
  public static AllMunicipalitiesKey = 'municipalities-all';
  public static MunicipalitiesKey = 'municipalities';
  public static BuildingCategoryKey = 'building-categories';
  public static PeriodsKey = 'periods';
  public static AccountKey = 'account';
  public static UserInstructionKey = 'user-instruction-';
}
